var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClient = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 10.5001C1.6665 8.32887 1.6665 7.24326 1.9442 6.36251C2.53286 4.49553 3.99528 3.0331 5.86227 2.44445C6.74302 2.16675 7.82862 2.16675 9.99984 2.16675C12.1711 2.16675 13.2567 2.16675 14.1374 2.44445C16.0044 3.0331 17.4668 4.49553 18.0555 6.36251C18.3332 7.24326 18.3332 8.32887 18.3332 10.5001C18.3332 12.6713 18.3332 13.7569 18.0555 14.6376C17.4668 16.5046 16.0044 17.9671 14.1374 18.5557C13.2567 18.8334 12.1711 18.8334 9.99984 18.8334C7.82862 18.8334 6.74302 18.8334 5.86227 18.5557C3.99528 17.9671 2.53286 16.5046 1.9442 14.6376C1.6665 13.7569 1.6665 12.6713 1.6665 10.5001Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1109 11.3334H8.88873C7.66143 11.3334 6.6665 12.3283 6.6665 13.5556C6.6665 14.1693 7.16396 14.6667 7.77761 14.6667H12.2221C12.8357 14.6667 13.3332 14.1693 13.3332 13.5556C13.3332 12.3283 12.3382 11.3334 11.1109 11.3334Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 7.16675C11.6665 8.08722 10.9203 8.83341 9.99984 8.83341C9.07936 8.83341 8.33317 8.08722 8.33317 7.16675C8.33317 6.24627 9.07936 5.50008 9.99984 5.50008C10.9203 5.50008 11.6665 6.24627 11.6665 7.16675Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClient);
export default ForwardRef;